/* EN — English. Glossary: Light / Darkness / Dawn / Eternal Night /
   Shrine / Relic / Depth / Spark / Light Power. */
export const en = {
  ui: {
    'html.rotate': 'Rotate your device<br>to landscape',

    'hud.level': 'LV {n}',
    'hud.gold': '{gem} {n}',
    'hud.eternalNight': '{spark} ETERNAL NIGHT',
    'hud.lightPower': '{bolt} DAMAGE ×1.6 · {s}s',
    'hud.boss': 'BOSS',
    'hud.coreLabel': 'CORE',
    'hud.heatLabel': 'heat · light {n}%',
    'hud.poleLo': 'WRATH +{n}%',
    'hud.poleHi': 'DAWN +{n}%',

    'banner.cache': 'CACHE — gold and a flash of light',
    'banner.font': 'FONT — healing and damage power',
    'banner.relic': 'RELIC — {name}',
    'banner.bossDown': '{name} DEFEATED',
    'banner.darkFork': 'FORK IN THE DARK',
    'banner.eliteWave': 'SHADE BREACH',
    'banner.heattide': 'HEAT TIDE',
    'banner.anomaly': 'DARK: {name}',
    'banner.evolution': 'EVOLUTION — {name}',
    'banner.synergy': 'SYNERGY — {name}',
    'banner.forge': 'FORGE — {name}',
    'banner.overclock': 'OVERCLOCK — {name}',
    'banner.enrage': '{name} — ENRAGED',
    'banner.snare': 'SNARE — HOLD THE ZONE!',
    'banner.snareWin': 'HEARTH KINDLED!',
    'banner.snareDefend': 'HEARTH — DEFEND!',
    'banner.snareDefendWin': 'HEARTH HELD!',
    'banner.snareFail': 'HEARTH LOST!',
    'banner.snareWaveCleared': 'WAVE CLEARED',
    'hud.snareWave': 'wave {n}/{total}',
    'hud.snareNextWave': 'next wave',
    'banner.revive': 'SECOND WIND',
    'banner.dawn': '{spark} D A W N {spark}',

    'menu.tagline': 'Grow. Or go cold.',
    'menu.subtitle': 'S U R V I V O R S',
    'menu.start': '{play} PLAY',
    'menu.shop': '{gem} SHOP',
    'menu.moveKeyboard': 'WASD / arrows — move      weapons fire on their own',
    'menu.moveTouch': 'drag finger — move      weapons fire on their own',
    'menu.hintCollect': 'collect sparks → level up → pick an upgrade',
    'menu.hintDawn': 'survive to Dawn (10:00) → then eternal night. head for {spark} light in the distance',
    'menu.best': 'best run: {time}',
    'menu.depthStat': 'depth: {n}/{total}',
    'menu.codexStat': 'codex: {n}/{total}',
    'menu.settings': '{gear} SETTINGS',

    'charselect.title': 'CHOOSE YOUR SPARK',
    'charselect.controls': '← →  select   ·   Enter / click — into battle',
    'charselect.locked': '???',
    'charselect.lockedFallback': 'locked',
    'charselect.surface': 'Surface',
    'charselect.depthTitle': 'DEPTH OF DARKNESS   ( ↑ ↓  or click ◂ ▸ )',
    'charselect.pathTitle': 'PATH   ( Q E  or click ◂ ▸ )',
    'charselect.depthReward': '{desc}   ·   reward ×{mult}',
    'charselect.depthLocked': 'survive to Dawn (10:00) — unlocks the Depth of Darkness (more threats and rewards)',

    'shop.title': 'LIGHT SHOP',
    'shop.back': '← BACK',
    'shop.controls': '↑ ↓  select   ·   Enter / click — buy   ·   Esc / M — back',
    'shop.max': 'MAX',
    'shop.trackForge': 'FORGE',
    'shop.trackHearth': 'CRUCIBLE',

    'draft.shrineTitle': '{spark} SHRINE {spark}',
    'draft.eventTitle': 'FORK IN THE DARK',
    'draft.anomalyTitle': '{moon} VOW OF DARKNESS {moon}',
    'draft.levelTitle': 'LEVEL {n}',
    'draft.shrineHint': 'choose a relic  ·  permanent for the run  ·  1 / 2 / 3',
    'draft.eventHint': 'choose a path  ·  no right answer  ·  1 / 2 / 3',
    'draft.anomalyHint': 'shape this night  ·  no turning back  ·  {n} left',
    'draft.levelHint': 'choose an upgrade  ·  1 / 2 / 3  or  click',
    'draft.reroll': '{cycle} reshuffle  ·  R  ·  once per run',
    'draft.snareTitle': 'SNARE — HOLD THE ZONE',
    'draft.snareHint': 'pick a boon  ·  stay in the zone — kindle rises  ·  1 / 2 / 3',
    'draft.snareDefendTitle': 'HEARTH — DEFEND',
    'draft.snareDefendHint': 'pick a boon  ·  defend the core from the swarm  ·  1 / 2 / 3',
    'draft.new': 'NEW',
    'draft.lvlChange': 'Lv {a} → {b}',

    'kind.event': 'FORK',
    'kind.evolve': '{star} EVOLUTION {star}',
    'kind.anomaly': '{moon} DARK VOW',
    'kind.relic': '{spark} RELIC',
    'kind.weapon': 'WEAPON',
    'kind.passive': 'PASSIVE',
    'kind.bonus': 'BONUS',
    'kind.boon': 'BOON',
    'kind.forge': 'FORGE',
    'kind.overclock': 'OVERCLOCK',
    'forge.ocName': 'Overclock: {w}',
    'forge.ocDesc': 'Beyond the lvl-5 cap — power for light. +{dmg}% damage · −{cost} light · stack {n}/{max}',

    'heal.name': 'Heal',
    'heal.desc': 'Restore 25% HP',

    'pause.title': 'PAUSED',
    'pause.stats': 'Lv {lvl}   ·   {time}   ·   {skull} {kills}   ·   light {light}',
    'pause.weapons': 'WEAPONS',
    'pause.passives': 'PASSIVES',
    'pause.relics': 'RELICS',
    'pause.synergies': 'SYNERGIES',
    'pause.victory': '{spark} LEAVE WITH THE DAWN — VICTORY (V)',
    'pause.resume': '{play} RESUME (ESC)',
    'pause.quit': 'TO MENU (Q)',
    'pause.settings': '{gear} SETTINGS',

    'settings.title': 'SETTINGS',
    'settings.back': '← BACK',
    'settings.volume': 'VOLUME',
    'settings.crt': 'RETRO CRT EFFECT',
    'settings.language': 'LANGUAGE',
    'settings.on': 'ON',
    'settings.off': 'OFF',

    'results.dead': 'YOU FELL',
    'results.finale': 'THE DEPTHS ARE CONQUERED',
    'results.survived': 'YOU SURVIVED!',
    'results.finaleSub': '{star} The dark is no more. You are the eternal Dawn. {star}',
    'results.winSub': 'Light overcame the dark. You became the dawn.',
    'results.demoTitle': 'DEMO COMPLETE',
    'results.demoSub': 'Full version: Depths of Darkness · boss second phases · more heroes, weapons & paths',
    'results.time': 'Survived',
    'results.level': 'Level',
    'results.kills': 'Kills',
    'results.bosses': 'Bosses',
    'results.score': 'Score',
    'results.gold': 'Gold',
    'results.relics': 'RELICS',
    'results.unlocked': '{spark} UNLOCKED: {names}',
    'results.restart': '{play}  SPACE / CLICK  —  RUN AGAIN',
    'results.menu': 'M  /  click  —  menu and shop',

    'speak.continue': 'click / space — onward',

    'rarity.rare': 'RARE',
    'rarity.legend': 'LEGENDARY',

    'unit.dmg': 'dmg',
    'unit.speed': 'speed',
    'unit.enemySlow': 'enemy speed',
    'unit.regen': 'HP/s',
    'unit.radius': 'pickup radius',
    'unit.hp': 'max HP',
    'unit.crit': 'crit chance',
    'unit.cooldown': 'cooldown',
    'unit.leech': 'HP per kill',
  },

  data: {
    enemies: {
      chaser: { name: 'Shade' }, swarm: { name: 'Wisp' }, tank: { name: 'Burden' },
      spitter: { name: 'Spitter' }, devourer: { name: 'Devourer' }, splitter: { name: 'Splitter' },
      splitling: { name: 'Shard' }, anchor: { name: 'Anchor' }, leech: { name: 'Disperser' },
      brute: { name: 'Colossus' }, boss: { name: 'Reaper' }, boss2: { name: 'Eclipse' },
      boss3: { name: 'Eclipse Lord' }, boss4: { name: 'Zero Point' },
      diver: { name: 'Lunger' }, sniper: { name: 'Stinger' }, boss5: { name: 'Titan' },
    },
    characters: {
      spark:  { name: 'Spark',      desc: 'Balanced in all things. Starts with: Bolt.' },
      ember:  { name: 'Ember',      desc: 'Glass cannon: +25% damage, but less HP and heat. Starts with: Bolt.' },
      umbra:  { name: 'Smoldering', desc: 'Burns bright but brief: heat fades, each kill buys a moment. Starts with: Bolt.' },
      mirror: { name: 'Turned',     desc: 'Heat is born from kills; damage quenches it. Starts with: Embersphere.' },
    },
    shop: {
      maxhp:  { name: 'Tempering',   desc: '+12 max HP per level' },
      power:  { name: 'Fury',        desc: '+5% damage per level' },
      speed:  { name: 'Swiftness',   desc: '+4% speed per level' },
      light:  { name: 'Radiance',    desc: '+20 heat per level' },
      revive: { name: 'Second Wind', desc: 'Rise once when slain' },
      reroll:  { name: 'Extra Coal',     desc: '+1 draft reshuffle per run' },
      beacons: { name: 'Shrine Memory',  desc: 'Shrines burn more often' },
      trove:   { name: 'Reliquary',      desc: '+1 relic in shrine choices' },
      anoma:   { name: 'Anomaly Forge',  desc: '+1 Vow of Darkness pick at start' },
    },
    weapons: {
      bolt:      { name: 'Bolt',       desc: 'A bolt of heat strikes the nearest' },
      orbit:     { name: 'Embersphere',desc: 'Spheres of heat orbit you, burning on touch' },
      nova:      { name: 'Flare',      desc: 'A blast wave of heat around you' },
      whip:      { name: 'Whip',       desc: 'A slashing strike in your direction' },
      chain:     { name: 'Wildfire',   desc: 'Fire leaps between enemies' },
      mine:      { name: 'Cinder',     desc: 'A smoldering cinder flares at an enemy' },
      beam:      { name: 'Heatray',    desc: 'A constant searing jet where you aim' },
      lantern:   { name: 'Forge',      desc: 'Drops a heat-zone: slows and burns the cold' },
      duskblade: { name: 'Ashblade',   desc: 'A blade of ash: hits harder the lower your heat' },
      ricochet:  { name: 'Ricochet',   desc: 'A mote ricochets off the dark, gaining heat' },
      dawnflash: { name: 'Outburst',   desc: 'Ult: an outburst of heat across the screen' },
    },
    evolutions: {
      dawnray:      { name: 'Salvo',         desc: 'A volley of homing sparks that pierce through' },
      corona:       { name: 'Corona',        desc: 'A ring of heat-spheres orbits you' },
      supernova:    { name: 'Conflagration', desc: 'A devastating wave of heat across the screen' },
      solaredge:    { name: 'Lash Fan',      desc: 'Slashes in every direction at once' },
      tempest:      { name: 'Firestorm',     desc: 'Fire strikes all nearby at once' },
      beacon:       { name: 'Ember Field',   desc: 'A field of bursting ember-traps' },
      sunlance:     { name: 'Burnthrough',   desc: 'A wide jet of heat burns through a rank' },
      lighthouse:   { name: 'Brazier',       desc: 'A colossal heat-zone — a fortress holds the night' },
      eclipseblade: { name: 'Ash Fan',       desc: 'A fan of ash-blades pierces the rank' },
      prism:        { name: 'Prism',         desc: 'A jet splits and ricochets endlessly' },
      daybreak:     { name: 'Eruption',      desc: 'A screen-wide eruption of heat blinds the dark' },
    },
    passives: {
      speed:  { name: 'Acceleration', desc: '+move speed' },
      power:  { name: 'Might',        desc: '+all damage' },
      regen:  { name: 'Regeneration', desc: '+HP recovery' },
      magnet: { name: 'Magnet',       desc: '+pickup radius' },
      vigor:  { name: 'Vigor',        desc: '+max HP' },
      crit:   { name: 'Precision',    desc: 'Critical hit chance (×2.2)' },
      haste:  { name: 'Rapid Fire',   desc: '−cooldown of all weapons' },
      leech:  { name: 'Heat Harvest', desc: 'Heals HP per kill' },
      bloom:  { name: 'Bloom',        desc: 'Slain enemies burst with heat' },
      frost:  { name: 'Frost',        desc: 'Aura slows the cold around you' },
      pulse:  { name: 'Heat Pulse',   desc: 'When hit → a wave of heat' },
    },
    forgeMods: {
      bolt_core:     { name: 'Molten Core',   desc: 'Impulse hits harder (+35%) and pierces 1 target' },
      bolt_shrapnel: { name: 'Shrapnel',      desc: 'Splits into a volley: +2 shots, each softer — a carpet of fire' },
      bolt_armor:    { name: 'Armor-Piercer', desc: 'One heavy rod: pierces the whole rank, but fewer shots' },
      orbit_core:    { name: 'Molten Ring',   desc: 'Spheres burn hotter (+30%) and the ring is wider — more contact' },
      orbit_swarm:   { name: 'Spark Swarm',   desc: '+2 spheres, each softer — a dense carousel' },
      orbit_one:     { name: 'Death by One',  desc: 'One fewer sphere, but heavy: ×1.9 damage and larger' },
      whip_core:     { name: 'Forged Swing',  desc: 'Strike hits harder (+30%) and knocks back stronger' },
      whip_sweep:    { name: 'Wide Sweep',    desc: 'Arc 70% wider and sweeps twice as hard — crowd control, softer per target' },
      whip_harpoon:  { name: 'Harpoon',       desc: 'A long narrow lance: twice the reach and heavier, but a thin band' },
      bolt_split:    { name: 'Midair Split',  desc: 'On hit the Impulse splits into 2 homing shards' },
      whip_grasp:    { name: 'Grasp',         desc: 'The whip PULLS enemies into the heat border instead of knocking them back' },
    },
    relics: {
      ember:    { name: 'Dawn Ember',    desc: '+22% damage permanently' },
      bulwark:  { name: 'Bulwark',       desc: '+45 max HP, +0.8 HP/sec' },
      swift:    { name: 'Courier',       desc: '+14% speed, ×1.8 magnet' },
      radiance: { name: 'Radiance',      desc: '+90 heat radius' },
      overload: { name: 'Overload',      desc: 'Weapons fire 18% faster' },
      famine:   { name: 'Thirst',        desc: 'Heals 0.9 HP per kill' },
      thorns:   { name: 'Crown of Wrath',desc: 'Heat constantly burns enemies around you' },
      greed:    { name: 'Greed',         desc: '×1.6 gold for the rest of the run' },
      umbralward: { name: 'Ember Wrath', desc: 'The lower your heat, the harder you hit: up to +60% in the dark' },
      dawncrown:  { name: 'Dawn Crown',  desc: 'The wider your heat, the harder you hit: up to +45% in the light' },
    },
    depths: {
      0: { name: 'Depth I',   desc: 'The cold thickens. Heat wanes.' },
      1: { name: 'Depth II',  desc: 'Enemies tougher, night closer.' },
      2: { name: 'Depth III', desc: 'Heat barely holds.' },
      3: { name: 'Depth IV',  desc: 'The abyss stares back.' },
      4: { name: 'Depth V',   desc: 'Only dawn can save you.' },
      5: { name: 'Depth VI',  desc: 'The end of heat.' },
    },
    anomalies: {
      twilight:  { name: 'Twilight',   desc: 'Heat radius −22%' },
      longnight: { name: 'Long Night', desc: 'Hits quench more heat' },
      swarmtide: { name: 'Swarm Tide', desc: 'Twice as many small fiends' },
      frenzy:    { name: 'Frenzy',     desc: 'Enemies faster, but more gold' },
      gloom:     { name: 'Gloom',      desc: 'Weaker magnet, but richer XP' },
      embertide: { name: 'Updraft',    desc: 'Heat grows faster, but the cold presses' },
      famine:    { name: 'Famine',     desc: 'The dark breeds larger fiends' },
      fragile:   { name: 'Fragility',  desc: 'Enemies hit harder but die easier' },
      embervow:  { name: 'Ash Vow',    desc: 'Heat shrinks, but wrath grows in the dark' },
    },
    darkEvents: {
      eliteWave: { name: 'Shade Breach',  desc: 'A wave of tough fiends at once — but a rich rain of gold' },
      curse:     { name: 'Gathering Dark',desc: 'A new dark rule for the rest of the run — in exchange, +15% damage permanently' },
      respite:   { name: 'Respite',       desc: 'Dispel nearby cold, +50% HP, heat flares' },
      fortune:   { name: 'Bounty',        desc: 'A rich rain of gold and a bit of health' },
      heattide:  { name: 'Heat Tide',     desc: 'Heat boils over: ×1.5 damage for a while and a radius flare' },
      rift:      { name: 'Rift',          desc: 'Drops a relic — but the crack lets the cold pour in' },
    },
    shrineKinds: {
      relic: { name: 'Shrine' }, cache: { name: 'Cache' }, font: { name: 'Font' }, snare: { name: 'Snare' },
    },
    snareBoons: {
      bulwark:  { name: 'Bulwark',  desc: '−55% incoming damage while held' },
      overheat: { name: 'Overheat', desc: 'Weapons fire ×2 faster, +25% damage' },
      pulsar:   { name: 'Pulsar',   desc: 'Heat waves knock back and burn the swarm' },
    },
    synergies: {
      ashEcho:      { name: 'Ash Echo' },
      darkForge:    { name: 'Forge of Dark' },
      smolderfield: { name: 'Smoldering Field' },
      sunPillar:    { name: 'Sun Pillar' },
      heatCorona:   { name: 'Heat Corona' },
      dawnSalvo:    { name: 'Dawn Salvo' },
      fireWhirl:    { name: 'Firewhirl' },
    },
    paths: {
      wanderer: { name: 'Wanderer',         desc: 'A plain beginning — the path is open, no vow.' },
      ash:      { name: 'Path of Ash',      desc: 'Dark build from the start: begin under the Ash Vow with Ember Wrath.' },
      dawn:     { name: 'Path of Dawn',     desc: 'Light build from the start: begin with the Dawn Crown and steady heat.' },
      swarm:    { name: 'Path of the Swarm',desc: 'Against the mass: begin with Wildfire and a Magnet.' },
    },
    unlocks: {
      beam:      { hint: 'Survive to 4:00' },
      lantern:   { hint: 'Defeat the first boss' },
      duskblade: { hint: 'Kill 1500 fiends (total)' },
      ricochet:  { hint: 'Reach level 14 in a run' },
      dawnflash: { hint: 'Reach Dawn (10:00)' },
      umbra:     { hint: 'Defeat a boss' },
      mirror:    { hint: 'Enter the Depth of Darkness' },
      ash:       { hint: 'Defeat the first boss' },
      swarm:     { hint: 'Kill 2000 fiends (total)' },
      dawn:      { hint: 'Reach Dawn (10:00)' },
      shrines:   { hint: 'Unlocked: Shrines — beacons in the distance hold relics, reach them' },
      events:    { hint: 'Unlocked: Dark Forks — a risk-choice with no right answer' },
      anomalies: { hint: 'Unlocked: Vow of the Dark — choose what darkness the run becomes' },
    },
  },

  // ASHFIELD lore (§14) — voice fragments. Iceberg: names a state/image, never explains.
  lore: {
    runNames: [
      'The Last Heat', 'Ash of the Third', 'The Corner That Remembers', 'Before the First Layer',
      "Someone Else's Burning", 'The Level Place', 'Before You Became a Streak', 'Below the Cold',
      'Where Shape Ends', 'Warmer Than Before', 'Imprint', 'Layer Zero',
    ],
    death: [
      'Heat leaves faster than you expect.',
      'Sharper first. Then even. Then nothing.',
      'First the edges. Then you.',
      "Ash doesn't remember what it was.",
      'The shape held longer than it should have.',
      'Somewhere here you started to look like everything else.',
      'The last thing to go is the name.',
      'To cool is to agree.',
      "You burned warmer than them. It wasn't enough.",
      'The geometry closed.',
      'Someone burned here before you. Got far, too.',
      'Not extinguished. Just — indistinct.',
    ],
    shrineRelic: [
      'Someone held this while it was still warm.',
      'Not your shape. Still — heat.',
      'They burned differently. This is what stayed.',
    ],
    shrineCache: [
      'Stored neatly. As if someone meant to return.',
      'Ash all around. Not here.',
      'Not abandoned. Hidden.',
    ],
    shrineFont: [
      'Where the heat comes from — unclear. It just comes.',
      'Here the shape holds on its own.',
      'Deeper is warmer. That should have been reassuring.',
    ],
    victory: [
      'You made it out. Or were let out.',
      "You've never burned deeper than this.",
      "You didn't cool. That was enough.",
    ],
    menuEarly: [
      "You didn't reach the place where shape starts to change.",
      'A spark. Just a spark, for now.',
    ],
    menuDeep: [
      "You've never been deeper. The ash is different here.",
    ],
    menuStreak: [
      'So many times cooled. And burning again.',
      "Three times this far. Someone's watching.",
    ],
    menuReturn: [
      "You're back. The Ashfield isn't surprised.",
    ],
    menuDefault: [
      "Either it's strength. Or you just don't notice the difference.",
      'Warm again. That counts for something.',
    ],
  },
};
